import React, { useEffect, useRef, useState } from "react";
import { Img } from "./Img";
import { Section } from "./Section";

export const SectionVideoBackdrop = ({ children, ...props }: Parameters<typeof Section>["0"]) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    const [playing, setPlaying] = useState(false);
    useEffect(() => {
        if (!videoRef.current) return;

        var observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        videoRef.current?.play();
                        setPlaying(true);
                    }, 300);
                    // console.log("set video source");
                    // timeout = setTimeout(() => {
                    //     if (!videoRef.current) return;
                    //     videoRef.current.src = getMedia("/images/Video_medium.mp4");
                    //     videoRef.current.load();
                    // }, 100);
                    // return;
                } else {
                    videoRef.current?.pause();
                }
            },
            {
                root: null, // default is the viewport
                threshold: 0.3, // percentage of target's visible area. Triggers "onIntersection"
            },
        );
        observer.observe(videoRef.current);
        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <Section relative={false} {...props}>
            {!playing && (
                <div className="absolute -z-10 left-0 top-0 w-full h-full">
                    <Img
                        className="w-full h-full object-cover"
                        alt=""
                        size="lg"
                        src="/pages/_assets/video-placeholder.png"
                    />
                </div>
            )}
            <div className="absolute left-0 top-0 w-full h-full">
                {/* <video
                    ref={videoRef}
                    loop
                    muted
                    playsInline
                    controls={false}
                    className="w-full h-full object-cover"
                    preload="none"
                    src={getMedia("/images/Video_medium.mp4")}
                /> */}
            </div>
            {children}
        </Section>
    );
};
